module.exports = __webpack_public_path__ + "img/hetong.8c5dbfe5.png";